// Thin host wrapper — National Team DNA profile. DNA + nations tables
// are a future C-phase migration; the hook degrades to null so the
// page renders its "Awaiting data" empty shell.
import { useParams, useNavigate } from "react-router-dom";
import { useIntlAccaDNA } from "../../intl-acca/useIntlAccaDNA.ts";
import { DNAProfilePage } from "./DNAProfilePage.tsx";

export function IntlAccaDnaRoute(): JSX.Element {
  const { tournamentId = "", teamCode = "" } = useParams();
  const navigate = useNavigate();
  const vm = useIntlAccaDNA(tournamentId, teamCode);
  return (
    <DNAProfilePage
      loading={vm.loading}
      error={vm.error}
      tournament={vm.tournament}
      nation={vm.nation}
      dna={vm.dna}
      onBack={() => navigate(`/intl-acca/${tournamentId}/hub`)}
      onSeeSlip={() => navigate(`/intl-acca/${tournamentId}`)}
    />
  );
}
